import React, { useState, useEffect } from "react";
import * as enums from "../../../../../utils/EnumMapping";
import { fmt } from "../../../../../utils/Util";
import ProjectAccordion from "./ProjectPhaseAccordion";
import ProjectPhaseHistory from "./ProjectPhaseHistory";
import ProjectPhaseDays from "./ProjectPhaseDays";
import ProjectPhaseDescription from "./ProjectPhaseDescription";
import ProjectPhaseAccordionContextMenu from "./ProjectPhaseAccordionContextMenu";
import ProjectPhaseEndDialogContent from "./ProjectPhaseEndDialogContent";
import ProjectPhaseDeleteDialog from "./ProjectPhaseDeleteDialog";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { Button } from "@material-ui/core";


export default function ProjectPhase({ title, phases = [], nextPhases = {} }) {
    const [openIndex, setOpenIndex] = useState(null);
    const [selectedPhases, setSelectedPhases] = useState([]);
    const [contextMenuAnchor, setContextMenuAnchor] = useState(null);
    const [contextMenuPhaseIndex, setContextMenuPhaseIndex] = useState(null);

    useEffect(() => {
        // console.log(selectedPhases);
    }, [selectedPhases])

    const handleToggleIndex = (idx) => {
        setOpenIndex((prev) => (prev === idx ? null : idx));
    };

    const handleChecked = (e, id) => {
        e.stopPropagation();
        setSelectedPhases(prev => prev.includes(id) ? prev.filter(e => e != id) : [...prev, id]);
    }

    const handleIsChecked = (id) => {
        return selectedPhases.includes(id);
    }

    const openContextMenu = (e, phaseIndex) => {
        e.stopPropagation();
        setContextMenuAnchor(e.currentTarget);
        setContextMenuPhaseIndex(phaseIndex);
    };

    const closeContextMenu = () => {
        setContextMenuAnchor(null);
        setContextMenuPhaseIndex(null);
    };

    // listen for reopen event from ProjectDetail after refresh
    useEffect(() => {
        const handler = (e) => {
            const { privateId } = (e && e.detail) || {};
            if (!privateId) return;
            const idx = (phases || []).findIndex(p => (p.phase && p.phase.privateId) === privateId);
            if (idx >= 0) {
                setOpenIndex(idx);
            }
        };
        window.addEventListener("projectphase:reopen", handler);
        return () => window.removeEventListener("projectphase:reopen", handler);
    }, [phases]);

    // listen for delete event to close all accordions
    useEffect(() => {
        const handler = (e) => {
            // Close all accordions when a phase is deleted
            setOpenIndex(null);
        };
        window.addEventListener("projectphase:deleted", handler);
        return () => window.removeEventListener("projectphase:deleted", handler);
    }, []);

    return (
        <div className="project-phases">
            <div className="phases-title">
                {title} <span className="count">({phases?.length || 0})</span>
            </div>

            <div className="phases-list">
                {phases?.length ? (
                    phases.map((p, i) => {
                        const summary = (
                            <div className="accordion-summary-wrapper">
                                <div className="summary-row">
                                    <div className="summary-left">
                                        <span className="phase-number">
                                            {/* {`${p.phase.phaseNumber}. ütem`} */}
                                            {p.phase.name}
                                        </span>
                                        <span className="phase-state-badge">
                                            {enums.getLabel(enums.projectPhaseStates, p.phase.state)}
                                        </span>
                                    </div>
                                </div>
                                <div className="summary-row">
                                    <span className="phase-dates">
                                        {fmt(p.phase.startDate)}
                                        {p.phase.endDate && ` — ${fmt(p.phase.endDate)}`}
                                    </span>
                                </div>
                            </div>
                        );

                        const actionButton = openIndex === i && (
                            <Button
                                size="small"
                                onClick={(e) => openContextMenu(e, i)}
                                className="context-menu-button"
                                aria-label="Fázis műveletek"
                                variant="contained"
                                color="primary"
                            >
                                Műveletek
                                {/* <MenuIcon key="menu-icon" color="primary" /> */}
                            </Button>
                        );

                        // extract the transitions object for this phase state from the map
                        const transitionsObj = (nextPhases && nextPhases[p.phase.state]) ? nextPhases[p.phase.state] : {};
                        // normalize to an array of { eventKey, nextStateKey }
                        const nextTransitions = Object.entries(transitionsObj || {}).map(([eventKey, nextStateKey]) => ({
                            eventKey,
                            nextStateKey
                        }));

                        return (
                            <ProjectAccordion
                                key={p.phase.id || i}
                                id={`phase-${i}`}
                                summary={summary}
                                open={openIndex === i}
                                onToggle={() => handleToggleIndex(i)}
                                onChecked={(e) => handleChecked(e, p.phase.privateId)}
                                isChecked={handleIsChecked(p.phase.privateId)}
                                actionButton={actionButton}
                            >
                                <div className="phase-details">

                                    <section className="phase-section phase-history-section">
                                        <div className="section-title">Ütem státusza</div>
                                        <div className="section-content">
                                            <ProjectPhaseHistory history={p.states || []} nextTransitions={nextTransitions} phasePrivateId={p.phase.privateId} />
                                        </div>
                                    </section>

                                    <section className="phase-section phase-description-section">
                                        <ProjectPhaseDescription phase={p.phase} />
                                    </section>

                                    <section className="phase-section phase-days-section">
                                        <div className="section-title">Munkanapok</div>
                                        <div className="section-content">
                                            <ProjectPhaseDays carDays={p.carDays} />
                                        </div>
                                    </section>
                                </div>
                            </ProjectAccordion>
                        );
                    })
                ) : (
                    <div className="empty">Nincs adat</div>
                )}
            </div>

            {contextMenuPhaseIndex !== null && phases[contextMenuPhaseIndex] && (
                <ProjectPhaseAccordionContextMenu
                    anchor={contextMenuAnchor}
                    phase={phases[contextMenuPhaseIndex]?.phase}
                    onClose={closeContextMenu}
                    menuItems={[
                        {
                            key: "endPhase",
                            label: phases[contextMenuPhaseIndex]?.phase?.endDate ? "Ütem kettébontása" : "Ütem végdátumának beállítása",
                            title: phases[contextMenuPhaseIndex]?.phase?.endDate ? "Ütem kettébontása" : "Ütem végdátumának beállítása",
                            content: (
                                <ProjectPhaseEndDialogContent
                                    phase={phases[contextMenuPhaseIndex]?.phase}
                                    onClose={closeContextMenu}
                                    onSuccess={() => {
                                        closeContextMenu();
                                        // Optionally refresh data
                                    }}
                                />
                            )
                        },
                        {
                            key: "delete",
                            label: "Ütem törlése",
                            title: "Ütem törlése",
                            content: (
                                <ProjectPhaseDeleteDialog
                                    phase={phases[contextMenuPhaseIndex]?.phase}
                                    onClose={closeContextMenu}
                                    onSuccess={() => {
                                        closeContextMenu();
                                        // Optionally refresh data
                                    }}
                                />
                            )
                        }
                    ]}
                />
            )}
        </div>
    );
}


